// TODO: Get rid of this enum, this kind of information should be provided by the environment variables.
// eslint-disable-next-line import/prefer-default-export
export enum Environment {
  Acceptance = 'acceptance',
  Production = 'production',
}
